<template>
    <v-dialog v-model="dialog" max-width="1200" persistent scrollable>
        <v-card class="elevation-12 rounded-xl">
            <v-toolbar color="primary" class="darken-1" flat dense border-bottom>
                <v-icon left color="white">mdi-file-import</v-icon>
                <span class="subtitle-1 font-weight-bold white--text text--darken-3">Importar Tareas</span>
                <v-spacer></v-spacer>
                <v-btn icon small @click="cancelImportLogs" :disabled="isImporting">
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text class="pa-6">
                <v-container fluid class="pa-0">
                    <div style="display: none;">
                        <s-select-definition :def="1528" @getDataInitial="getDataClasification" />
                        <s-select-definition :def="1392" @getDataInitial="getDataPriority" />
                        <s-select-definition :def="1393" @getDataInitial="getDataStatus" />
                        <s-select-definition :def="1476" @getDataInitial="getDataTypeTask" />
                    </div>

                    <v-row justify="center" align="center">
                        <v-col cols="12" sm="10" md="8">
                            <v-hover v-slot="{ hover }">
                                <div :class="[
                                    'upload-area',
                                    { 'hovering': hover && filterTkpID && filterTkpID !== 0 },
                                    { 'file-ready': importFile },
                                    { 'disabled-area': !filterTkpID || filterTkpID === 0 }
                                ]" @click="(!filterTkpID || filterTkpID === 0) ? null : $refs.fileInput.click()">

                                    <input type="file" ref="fileInput" style="display: none" accept=".txt,.xlsx,.xls"
                                        @change="onFileChange">

                                    <div class="upload-content text-center py-8">
                                        <v-icon size="64" :color="importFile ? 'success' : (hover ? 'primary' : 'grey')"
                                            class="mb-4">
                                            {{ importFile ? 'mdi-file-check' : 'mdi-cloud-upload' }}
                                        </v-icon>

                                        <div v-if="!importFile">
                                            <div class="text-h6 font-weight-bold grey--text text--darken-2">
                                                Seleccionar archivo de Tareas
                                            </div>
                                            <div class="text-subtitle-2 grey--text mt-1">
                                                Haz clic para buscar el archivo .txt o .xlsx
                                            </div>
                                        </div>

                                        <div v-else>
                                            <div class="text-h6 font-weight-bold success--text">
                                                {{ importFile.name }}
                                            </div>
                                            <div class="text-subtitle-2 success--text mt-1">
                                                Archivo cargado correctamente
                                            </div>
                                        </div>

                                        <v-progress-linear v-if="isLoadingFile" indeterminate absolute bottom
                                            color="primary"></v-progress-linear>
                                    </div>
                                </div>
                            </v-hover>
                        </v-col>
                    </v-row>

                    <v-col cols="12">
                        <v-row class="mt-0" justify="center" align="center">
                            <v-btn v-if="processedLogs.length > 0" color="error" depressed outlined @click="resetImport"
                                :disabled="isImporting" class="mr-4">
                                <v-icon left>mdi-refresh</v-icon> Limpiar Importación
                            </v-btn>

                            <v-chip v-if="!filterTkpID || filterTkpID === 0" color="warning" outlined label
                                class="rounded-lg">
                                <v-icon left small>mdi-alert-circle-outline</v-icon>
                                No se ha seleccionado un proyecto
                            </v-chip>
                        </v-row>
                    </v-col>

                    <v-divider class="my-2"></v-divider>

                    <v-row v-if="isLoadingFile">
                        <v-col cols="12" class="text-center py-8">
                            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
                            <div class="mt-4 grey--text text--darken-1 font-weight-medium text-subtitle-1">
                                Procesando archivo...
                            </div>
                        </v-col>
                    </v-row>

                    <div v-else>
                        <div v-if="processedLogs.length > 0">
                            <div class="d-flex align-center justify-space-between my-2">
                                <h4 class="subtitle-1 font-weight-medium">
                                    <v-icon color="success" class="mr-1">mdi-check-circle-outline</v-icon>
                                    Líneas encontradas: <span class="primary--text">
                                        {{ filteredImportLogs.length }}</span>
                                    <span v-if="filteredImportLogs.length !== processedLogs.length"
                                        class="caption grey--text ml-2">
                                        (Filtradas de {{ processedLogs.length }})
                                    </span>
                                </h4>
                                <v-chip color="info" outlined small label>
                                    Proyecto: {{ proyectTkpTitle }}
                                </v-chip>
                            </div>

                            <v-container class="pa-0 mb-2" fluid>
                                <v-row class="flex align-center">
                                    <v-col cols="12" sm="3" md="3" lg="3">
                                        <s-date label="Desde" type="datetime" v-model="importFilterBegin"
                                            clearable></s-date>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="3" lg="3">
                                        <s-date label="Hasta" type="datetime" v-model="importFilterEnd"
                                            clearable></s-date>
                                    </v-col>
                                </v-row>
                            </v-container>

                            <v-data-table :headers="importHeaders" :items="filteredImportLogs" :items-per-page="25"
                                dense class="elevation-1 rounded-lg border-table" mobile-breakpoint="0">
                                <template v-slot:[`item.TskRequestDate`]="{ item }">
                                    {{ $fun.formatDateTimeView(item.TskRequestDate) }}
                                </template>
                                <template v-slot:[`item.TskTitle`]="{ item }">
                                    <span class="font-weight-bold text-truncate d-inline-block"
                                        style="max-width: 200px;">{{ item.TskTitle }}</span>
                                </template>
                                <template v-slot:[`item.TskDescription`]="{ item }">
                                    <span class="d-inline-block" style="max-width: 250px;">{{ item.TskDescription
                                        }}</span>
                                </template>
                                <template v-slot:[`item.TskPriorityName`]="{ item }">
                                    <v-chip x-small dark
                                        :color="item.TskPriorityName === 'BAJA' ? 'green' : (item.TskPriorityName === 'MEDIA' ? 'orange' : 'red')">
                                        {{ item.TskPriorityName }}
                                    </v-chip>
                                </template>
                                <template v-slot:[`item.TskCriticalityName`]="{ item }">
                                    <v-chip x-small dark
                                        :color="item.TskCriticalityName === 'BAJA' ? 'green' : (item.TskCriticalityName === 'MEDIA' ? 'orange' : 'red')">
                                        {{ item.TskCriticalityName }}
                                    </v-chip>
                                </template>
                                <template v-slot:[`item.TskStatusName`]="{ item }">
                                    <v-chip x-small dark
                                        :color="item.TskStatusName === 'FINALIZADO' ? 'green' : 'orange'">
                                        {{ item.TskStatusName }}
                                    </v-chip>
                                </template>
                            </v-data-table>
                        </div>

                        <v-row v-else-if="importFile" class="text-center py-12">
                            <v-col cols="12">
                                <v-icon size="80" color="grey lighten-2">mdi-file-search-outline</v-icon>
                                <h3 class="grey--text text--darken-1 mt-4">Sin resultados</h3>
                                <p class="grey--text">No se encontraron líneas que coincidan con las reglas.</p>
                            </v-col>
                        </v-row>

                        <v-row v-else class="text-center py-12">
                            <v-col cols="12">
                                <v-icon size="80" color="grey lighten-3">mdi-cloud-upload-outline</v-icon>
                                <h3 class="grey--text lighten-2 mt-4">Sube un archivo para empezar</h3>
                                <p class="grey--text lighten-2">Analizaremos el contenido para extraer las tareas
                                    automáticamente.</p>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </v-card-text>

            <v-card-actions class="pa-4 grey lighten-5 border-top">
                <v-spacer></v-spacer>
                <v-btn text color="grey darken-2" @click="cancelImportLogs" :disabled="isImporting">
                    Cancelar
                </v-btn>
                <v-btn color="info" class="elevation-2 font-weight-medium px-6" @click="importLogs"
                    :disabled="processedLogs.length === 0 || isLoadingFile" :loading="isImporting">
                    <v-icon left>mdi-cloud-upload</v-icon>
                    Importar Registros
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import _sTaskService from '@/services/InformationTechnology/TaskService.js';

export default {
    name: 'TaskImportModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        filterTkpID: {
            type: Number,
            default: 0
        },
        proyectTkpTitle: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            importFile: null,
            processedLogs: [],
            isImporting: false,
            isLoadingFile: false,
            importFilterBegin: null,
            importFilterEnd: null,
            itemsClasification: [],
            itemsPriority: [],
            itemsStatus: [],
            itemsTypeTask: [],
            importHeaders: [
                { text: 'Título', value: 'TskTitle' },
                { text: 'Descripción', value: 'TskDescription' },
                { text: 'Fecha Solicitud', value: 'TskRequestDate' },
                { text: 'Fecha Fin', value: 'TskDateBegin' },
                { text: 'Clasificación', value: 'TypeClasificationName', align: 'center' },
                { text: 'Prioridad', value: 'TskPriorityName', align: 'center' },
                { text: 'Criticidad', value: 'TskCriticalityName', align: 'center' },
                { text: 'Estado', value: 'TskStatusName', align: 'center' },
            ],
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        filteredImportLogs() {
            if (!this.processedLogs || this.processedLogs.length === 0) return [];
            return this.processedLogs.filter(log => {
                const logDate = this.$moment(log.TskRequestDate, 'YYYY-MM-DD HH:mm:ss');
                if (this.importFilterBegin) {
                    const begin = this.$moment(this.importFilterBegin);
                    if (logDate.isBefore(begin)) return false;
                }
                if (this.importFilterEnd) {
                    const end = this.$moment(this.importFilterEnd);
                    if (logDate.isAfter(end)) return false;
                }
                return true;
            });
        }
    },
    watch: {
        dialog(val) {
            if (val) {
                this.resetImport();
            }
        }
    },
    methods: {
        getDataClasification(items) { this.itemsClasification = items; },
        getDataPriority(items) { this.itemsPriority = items; },
        getDataStatus(items) { this.itemsStatus = items; },
        getDataTypeTask(items) { this.itemsTypeTask = items; },

        cancelImportLogs() {
            this.dialog = false;
            this.resetImport();
        },
        resetImport() {
            this.importFile = null;
            this.processedLogs = [];
            this.isLoadingFile = false;
            this.importFilterBegin = null;
            this.importFilterEnd = null;
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        },
        onFileChange(e) {
            const files = e.target.files;
            if (files.length > 0) {
                const file = files[0];
                this.importFile = file;
                const extension = file.name.split('.').pop().toLowerCase();
                if (extension === 'xlsx' || extension === 'xls') {
                    this.handleExcelUpload();
                } else {
                    this.handleFileUpload();
                }
            }
        },
        handleFileUpload() {
            if (!this.importFile) {
                this.processedLogs = [];
                return;
            }
            this.isLoadingFile = true;
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const content = e.target.result;
                    const lines = content.split(/\r?\n/);
                    const results = [];
                    await new Promise(resolve => setTimeout(resolve, 500));
                    lines.forEach(line => {
                        if (line.trim()) {
                            const processed = this.processLogLine(line);
                            if (processed) {
                                results.push(processed);
                            }
                        }
                    });
                    this.processedLogs = results;
                } catch (error) {
                    console.error("Error processing file:", error);
                    this.$fun.alert("Error al procesar el archivo", "error");
                } finally {
                    this.isLoadingFile = false;
                }
            };
            reader.onerror = () => {
                this.$fun.alert("Error al leer el archivo", "error");
                this.isLoadingFile = false;
            };
            reader.readAsText(this.importFile);
        },
        async handleExcelUpload() {
            if (!this.importFile) {
                this.processedLogs = [];
                return;
            }
            this.isLoadingFile = true;
            try {
                const ExcelJS = require("exceljs");
                const workbook = new ExcelJS.Workbook();
                const reader = new FileReader();
                const buffer = await new Promise((resolve, reject) => {
                    reader.onload = (e) => resolve(e.target.result);
                    reader.onerror = (e) => reject(e);
                    reader.readAsArrayBuffer(this.importFile);
                });
                await workbook.xlsx.load(buffer);
                const worksheet = workbook.getWorksheet(1);
                const results = [];
                const expectedHeaders = ['item', 'titulo', 'descripcion', 'fecha_requerimiento', 'fecha_finalizacion', 'clasificacion', 'prioridad', 'criticidad', 'estado'];
                let headerRowIndex = -1;
                let colIndices = { title: -1, description: -1, date: -1, dateEnd: -1, clasification: -1, priority: -1, criticidad: -1, status: -1 };
                worksheet.eachRow((row, rowNumber) => {
                    if (headerRowIndex !== -1) return;
                    const rowValues = row.values;
                    if (Array.isArray(rowValues)) {
                        const foundHeaders = rowValues.map(v => (v ? v.toString().toLowerCase().trim() : ''));
                        const matches = expectedHeaders.filter(h => foundHeaders.includes(h));
                        if (matches.length >= expectedHeaders.length - 2 || rowNumber === 2) {
                            headerRowIndex = rowNumber;
                            colIndices.title = foundHeaders.indexOf('titulo');
                            colIndices.description = foundHeaders.indexOf('descripcion');
                            colIndices.date = foundHeaders.indexOf('fecha_requerimiento');
                            colIndices.dateEnd = foundHeaders.indexOf('fecha_finalizacion');
                            colIndices.clasification = foundHeaders.indexOf('clasificacion');
                            colIndices.priority = foundHeaders.indexOf('prioridad');
                            colIndices.criticidad = foundHeaders.indexOf('criticidad');
                            colIndices.status = foundHeaders.indexOf('estado');
                        }
                    }
                });
                if (headerRowIndex === -1) {
                    this.$fun.alert("No se encontraron los encabezados requeridos", "warning");
                    this.resetImport();
                    return;
                }
                worksheet.eachRow((row, rowNumber) => {
                    if (rowNumber <= headerRowIndex) return;
                    const rowValues = row.values;
                    const logTitle = rowValues[colIndices.title] ? rowValues[colIndices.title].toString() : '';
                    const logDescription = rowValues[colIndices.description] ? rowValues[colIndices.description].toString() : '';
                    const logDate = rowValues[colIndices.date];
                    const logDateEnd = rowValues[colIndices.dateEnd];
                    const logClasification = rowValues[colIndices.clasification] ? rowValues[colIndices.clasification].toString() : null;
                    const logPriority = rowValues[colIndices.priority] ? rowValues[colIndices.priority].toString() : null;
                    const logCriticidad = rowValues[colIndices.criticidad] ? rowValues[colIndices.criticidad].toString() : null;
                    const logStatus = rowValues[colIndices.status] ? rowValues[colIndices.status].toString() : null;
                    results.push({
                        TskID: 0,
                        TskCriticality: this.itemsPriority.find(x => x.DedDescription.toLowerCase() === logCriticidad?.toLowerCase())?.DedValue || null,
                        TskCriticalityName: logCriticidad || 2,
                        TypeTask: 1,
                        TskRequestDate: logDate instanceof Date ? this.$moment(logDate).format('YYYY-MM-DD HH:mm:ss') : logDate,
                        TskDateBegin: logStatus?.toLowerCase() === 'pausado' ? null : logDateEnd instanceof Date ? this.$moment(logDateEnd).format('YYYY-MM-DD HH:mm:ss') : logDateEnd,
                        TskTimeRequired: "00:00:00",
                        TskValidateRequiredTime: logStatus?.toLowerCase() === 'finalizado' ? 1 : 0,
                        TypeClasification: this.itemsClasification.find(x => x.DedDescription?.toLowerCase() === logClasification?.toLowerCase())?.DedValue || null,
                        TypeClasificationName: logClasification,
                        TskTitle: logTitle || "Importación Excel",
                        TskDescription: logDescription,
                        TskPriority: this.itemsPriority.find(x => x.DedDescription?.toLowerCase() === logPriority?.toLowerCase())?.DedValue || null,
                        TskPriorityName: logPriority,
                        TskStatus: this.itemsStatus.find(x => x.DedDescription?.toLowerCase() === logStatus?.toLowerCase())?.DedValue || null,
                        TskStatusName: logStatus,
                        TskPaused: logStatus?.toLowerCase() === 'pausado' ? 1 : 0,
                        TkpID: this.filterTkpID,
                        AreID: 0,
                        PrsID: null,
                        SecStatus: 1,
                        UsrCreateID: this.$fun.getUserID(),
                        UsrID: this.$fun.getUserID(),
                    });
                });
                this.processedLogs = results;
                if (results.length === 0) {
                    this.$fun.alert("No se encontraron registros", "info");
                }
            } catch (error) {
                console.error("Error processing Excel:", error);
                this.$fun.alert("Error al procesar el archivo Excel", "error");
            } finally {
                this.isLoadingFile = false;
            }
        },
        processLogLine(line) {
            const logRegex = /^\[(.*?)\]\s*\[(.*?)\]\s*(.*)$/;
            const match = line.match(logRegex);
            if (match) {
                const logDate = match[1];
                const logStatus = match[2];
                const logDescription = match[3];
                if (!logDescription.includes('/reiniciar')) {
                    return null;
                }
                return {
                    TskID: 0,
                    TskCriticality: 2,
                    TskCriticalityName: 'MEDIA',
                    TypeTask: 1,
                    TskRequestDate: logDate,
                    TskDateBegin: logDate,
                    TskTimeRequired: "00:00:05",
                    TskValidateRequiredTime: 1,
                    TypeClasification: 1,
                    TypeClasificationName: 'TAREA',
                    TskTitle: "REINICIAR IIS",
                    TskDescription: logDescription + " - " + logStatus,
                    TskPriority: 2,
                    TskPriorityName: 'MEDIA',
                    TskStatus: 3,
                    TskStatusName: 'FINALIZADO',
                    TskPaused: 0,
                    TkpID: this.filterTkpID,
                    AreID: 0,
                    PrsID: null,
                    SecStatus: 1,
                    UsrCreateID: this.$fun.getUserID(),
                    UsrID: this.$fun.getUserID(),
                };
            }
            return null;
        },
        importLogs() {
            if (this.processedLogs.length === 0) {
                this.$fun.alert("No hay registros para importar", "warning");
                return;
            }
            if (this.filterTkpID === 0 || !this.filterTkpID) {
                this.$fun.alert("Seleccione un proyecto", "warning");
                return;
            }
            for (const task of this.filteredImportLogs) {
                if (!task.TypeClasification) {
                    this.$fun.alert(`La tarea "${task.TskTitle}" no tiene una Clasificación válida`, "warning");
                    return;
                }
                if (!task.TskPriority) {
                    this.$fun.alert(`La tarea "${task.TskTitle}" no tiene una Prioridad válida`, "warning");
                    return;
                }
                if (!task.TskCriticality) {
                    this.$fun.alert(`La tarea "${task.TskTitle}" no tiene una Criticidad válida`, "warning");
                    return;
                }
                if (!task.TskStatus) {
                    this.$fun.alert(`La tarea "${task.TskTitle}" no tiene un Estado válido`, "warning");
                    return;
                }
            }
            this.isImporting = true;
            try {
                const userInfo = this.$fun.getUserInfo();
                const tasks = this.filteredImportLogs.map(x => ({
                    ...x,
                    TkpID: this.filterTkpID,
                    AreID: (userInfo && userInfo.CtrContract) ? (userInfo.CtrContract.AreID ?? 0) : 0,
                    PrsID: (userInfo) ? (userInfo.PrsID ?? null) : null,
                }))

                // console.log(JSON.parse(JSON.stringify(tasks)))
                _sTaskService.saveMassive(tasks, this.$fun.getUserID()).then(response => {
                    if (response && response.status === 200) {
                        this.$fun.alert(`Importación finalizada correctamente`, 'success');
                        this.$emit('imported');
                        this.dialog = false;
                        this.resetImport();
                    }
                });
            } catch (globalErr) {
                this.$fun.alert("Ocurrió un error general durante la importación", "error");
            } finally {
                this.isImporting = false;
            }
        }
    }
};
</script>
<style scoped>
.rounded-xl {
    border-radius: 16px !important;
}

.upload-area {
    border: 2px dashed #E0E0E0;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    background-color: #fafafa;
    position: relative;
    overflow: hidden;
}

.upload-area.hovering {
    border-color: #3f51b5;
    background-color: #f0f2ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.upload-area.file-ready {
    border-style: solid;
    border-color: #4CAF50;
    background-color: #f1f8e9;
}

.text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 70%;
}
</style>
